import { render, staticRenderFns } from "./DetailRowPartenaires.vue?vue&type=template&id=f4a71910&scoped=true&"
import script from "./DetailRowPartenaires.vue?vue&type=script&lang=js&"
export * from "./DetailRowPartenaires.vue?vue&type=script&lang=js&"
import style0 from "./DetailRowPartenaires.vue?vue&type=style&index=0&id=f4a71910&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4a71910",
  null
  
)

export default component.exports